import { MontageType } from '@/api/ProductTypeApi';
import { CreatorState, SegmentJoint } from '@/types/creator';
import { getSegmentSequences } from '@/utils/creatorUtils';
import { WritableDraft } from '@reduxjs/toolkit';
import ConfigurationRenderer from './ConfigurationRenderer';
import ConfigurationDrawer from './ConfigurationDrawer';
import Segment from './objects/Segment';
import APP_CONFIG from '@/configs/appConfig';

class ConfigurationManager {
	withArmor = false;
	montageType = MontageType.INSIDE;
	rollerBoxHeight: number = APP_CONFIG.CONFIGURATION_DEFAULTS.ROLLER_BOX.HEIGHT;
	segments: Segment[] = [];
	segmentSequences: Segment[][] = [];
	drawer: ConfigurationDrawer;
	segmentJoints: SegmentJoint[] = [];

	constructor(private renderer: ConfigurationRenderer) {
		this.drawer = new ConfigurationDrawer(renderer, this);
	}

	initialize() {
		this.drawer.initialize();
	}

	setFromCreatorState(creatorState: WritableDraft<CreatorState>) {
		this.clear();

		this.withArmor = creatorState.configurationConfig.project.withArmor;

		this.rollerBoxHeight = creatorState.projectDimensions.rollerBoxHeight;
		this.segmentJoints = creatorState.segmentJoints;

		creatorState.segments.forEach((creatorSegment, idx) => {
			const prevJoint = this.segmentJoints[idx - 1],
				nextJoint = this.segmentJoints[idx];

			const segment = new Segment(this.renderer, prevJoint, nextJoint);

			segment.setFromCreatorSegment(creatorSegment);
			this.segments.push(segment);
		});

		this.segmentSequences = getSegmentSequences(
			this.segments,
			this.segmentJoints
		);

		this.drawer.build();
	}

	clear() {
		this.drawer.clear();

		for (const segment of this.segments) {
			segment.destroy();
		}
		this.segments = [];
		this.segmentSequences = [];
	}
}

export default ConfigurationManager;
